import { Countries } from '../../../shared/enums';
import { fetchData } from './utils';

export interface MetaFanpage {
  fbPage: string;
  fbPageId: string;
  igPage: string;
  igPageId: string;
}
export interface ApiResponse<T> {
  status: string;
  data: T;
}

export const getFanpages = async (
  countryISO: Countries,
  division: string,
  category: string,
  brand: string
) => {
  return fetchData<ApiResponse<MetaFanpage[]>>(
    `/campaign/v2/fanpages?division=${division}&countryISO=${countryISO}&brand=${brand}&category=${category}`
  );
};
